"use client";
import React, { useRef } from "react";
import "./index.css";
import Marquee from "react-fast-marquee";

const MarqueeDiv = () => {
  const marqueeDiv = useRef(null);

  const listMarquee = [
    "Convenience At Your Fingertips",
    "Personalized Service",
    "Expertise You Can Trust",
    "Convenience At Your Fingertips",
    "Personalized Service",
    "Expertise You Can Trust",
  ];

  return (
    <div className="relative">
      <div className="marqueeDiv" ref={marqueeDiv}>
        <Marquee>
          {listMarquee.map((text) => (
            <span className="wordMarquee" key={text + Math.random()}>
              {text} -
            </span>
          ))}
        </Marquee>
      </div>
      <div className="backMarquee"></div>
    </div>
  );
};

export default MarqueeDiv;
